<template>
  <div class="">
    <div class="w-full mt-28 px-8">
      <Adminmain />
    </div>
  </div>
</template>

<script>
import Adminmain from "./components/Adminmain.vue";

export default {
  components: {
    Adminmain,
  },
};
</script>
